export default __webpack_public_path__ + "static/media/pelatihan-card-icon.85256866.webp";